(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("dQcqH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a139c5f71097989c$export$2e2bcd8739ae039; });

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");
var $a139c5f71097989c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Search(param) {
        var el = param.el;
        (0, $J7ygF._)(this, Search);
        this.el = el;
        this.form = this.el.querySelector('form');
        this.input = this.form.querySelector('input[type="search"]');
        this.closer = this.el.querySelector('.search-closer');
        this.openers = Array.from(document.querySelectorAll('.search-opener'));
        // this el has to be outside of the header for mix blend mode to work as expected
        this.results = document.querySelector('#predictive-search-container .results');
        this.init();
    }
    (0, $hvJJn._)(Search, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.openers.forEach(function(opener) {
                    opener.addEventListener('click', function() {
                        _this.open();
                    });
                });
                this.input.addEventListener('input', this.debounce(function(event) {
                    _this.onChange(event);
                }, 300).bind(this));
                this.closer.addEventListener('click', function() {
                    _this.close();
                });
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                var searchTerm = this.input.value.trim();
                this.getSearchResults(searchTerm);
            }
        },
        {
            key: "getSearchResults",
            value: function getSearchResults(searchTerm) {
                var _this = this;
                // if search term empty, hide results and show suggested searches
                if (!searchTerm.length) {
                    this.el.classList.remove('search-in-progress');
                    return;
                }
                // if there is a search term, show results
                this.el.classList.add('search-in-progress');
                this.results.innerHTML = '<div class="loading px-base text-xs uppercase tracking-def flex justify-center"><p>Loading...</p></div>';
                fetch("/search/suggest?q=".concat(searchTerm, "&resources[type]=product,page,article,query&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=hide&section_id=predictive-search")).then(function(response) {
                    if (!response.ok) {
                        var error = new Error(response.status);
                        _this.close();
                        throw error;
                    }
                    return response.text();
                }).then(function(text) {
                    var resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
                    _this.results.innerHTML = resultsMarkup;
                // this.open();
                }).catch(function(error) {
                    _this.close();
                    throw error;
                });
            }
        },
        {
            key: "open",
            value: function open() {
                this.input.value = '';
                this.el.classList.add('active');
                this.input.focus();
            }
        },
        {
            key: "close",
            value: function close() {
                var _this = this;
                this.el.classList.remove('active');
                setTimeout(function() {
                    _this.input.value = '';
                }, 350);
            }
        },
        {
            key: "debounce",
            value: function debounce(fn, wait) {
                var _this = this;
                var t;
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    clearTimeout(t);
                    t = setTimeout(function() {
                        return fn.apply(_this, args);
                    }, wait);
                };
            }
        }
    ]);
    return Search;
}();

});
parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});


})();
//# sourceMappingURL=Search.4e9f52d7.js.map
